<script>
import Vue from 'vue'
import { MODAL } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import ClientSearch from '@components/client-search.vue'

export default {
  name: 'ConsolidatorSelectClient',
  components: { ClientSearch },
  data() {
    return {
      busModal: new Vue(),
      isOpen: false,
    }
  },
  created() {
    GlobalBus.$on(MODAL.CONSOLIDATOR_SELECT_CLIENT, this.open)
    GlobalBus.$on('changeClient', this.handleClientChanged)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.CONSOLIDATOR_SELECT_CLIENT, this.open)
    GlobalBus.$off('changeClient', this.handleClientChanged)
  },
  methods: {
    open() {
      this.isOpen = true
      this.busModal.$emit('dialog', true)
    },
    handleClientChanged() {
      if (!this.isOpen) return
      this.isOpen = false
      this.busModal.$emit('dialog', false)
    },
  },
}
</script>

<template>
  <BaseModal
    :bus="busModal"
    centerScreen
    centerAndDecreasesPadding
    maxWidth="500px"
    closeColor="#8e8e8e"
    backgroundColor="white"
    content-class="consolidator-select-client-modal"
  >
    <div class="pb-6 consolidator-select-client">
      <div class="modal-title-container">
        <span class="modal-title"> Selecionar cliente </span>
      </div>

      <div class="modal-content">
        <p class="text-sm text-color-900 mb-4">
          Selecione o cliente para visualizar a carteira dele.
        </p>

        <ClientSearch outlined class="new-ux" />
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
    </template>
  </BaseModal>
</template>

<style lang="sass">
.consolidator-select-client-modal
  .v-autocomplete
    max-width: 100% !important

  .modal-actions
    justify-content: flex-end

    .spacer
      display: none
</style>
